import { ApiCallError } from 'app/http/ApiCallError';

export const isRetryableAnalysisPollError = (error: unknown) =>
  !(error instanceof ApiCallError) || error.status === undefined || error.status >= 500;
